import { AGSGateWin } from "integration/schema/ags-gate-win";
import Result from "slotworks/model/gameplay/records/results/result";
import Record from "slotworks/model/gameplay/records/record";
import { AGSResultBuilder } from "ags/integration/builders/results/abstract-ags-result-builder";
import BonusResult from "slotworks/model/gameplay/records/results/bonus-result";
import Point from "slotworks/utils/geom/point";
import FreespinScatterResult from "ags/integration/builders/results/freespin-scatter-result";

export interface LLWildBonusPick extends AGSGateWin {
    wildIndex: number;
}

export class LLWildSymbolResult extends FreespinScatterResult {
}

export class LLWildBonusResult extends BonusResult {
    public wildPosition: number[];
}

class LLWildBonusResultBuilder extends AGSResultBuilder {
    public filter(response: LLWildBonusPick): boolean {
        return response.wildIndex !== undefined && response.wildIndex > 0;
    }

    public build(record: Record, response: LLWildBonusPick): Result[] {

        const bonusResult = new LLWildBonusResult("pick");
        bonusResult.wildPosition = this.getWildPosition(response);

        const x = bonusResult.wildPosition[1];
        const y = bonusResult.wildPosition[0];

        const symbolWinResult = new LLWildSymbolResult();
        symbolWinResult.matches = 1;
        symbolWinResult.symbolType = "WW_BN";
        symbolWinResult.positions = [new Point(x, y)];

        return [bonusResult, symbolWinResult];
    }

    private getWildPosition(spin: LLWildBonusPick) {
        const wildPositions = this.generateWildPositions();
        return wildPositions[spin.wildIndex - 1];
    }

    private generateWildPositions() {
        const columns = Array.from(Array(5).keys());
        const rows = Array.from(Array(3).keys());
        const wildPositions: number[][] = [];

        rows.forEach((rowIndex) => {
            columns.forEach((columnIndex) => {
                wildPositions.push([rowIndex, columnIndex]);
            });
        });

        return wildPositions;
    }
}

export default new LLWildBonusResultBuilder();
